import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import { DEFAULT_WINDOW_NIGHTS, canPageBack, canPageForward, clampWindowStart, formatWindowLabel, pageWindowStart, rangeNights, todayWindowStart, windowFrom } from './dateWindow';
const NIGHTS = DEFAULT_WINDOW_NIGHTS;
// A stand-in range for the window math before any search has run. Never drives a
// request — the toolbar and cards are only shown once a real range exists.
const PLACEHOLDER_RANGE = { start: '1970-01-01', end: '1970-01-08' };
// Owns the availability calendar's visible date window: a fixed-width window
// that pages within the wider search range. Lifted out of AvailabilityView so
// the toolbar can live in the page header (aligning the calendar and quote
// cards) while the window still drives the cards below.
export const useDateWindow = (range) => {
    const activeRange = range ?? PLACEHOLDER_RANGE;
    const [windowStart, setWindowStart] = useState(() => clampWindowStart(activeRange.start, activeRange, NIGHTS));
    // A new search resets the window to the start of the new range.
    useEffect(() => {
        setWindowStart(clampWindowStart(activeRange.start, activeRange, NIGHTS));
    }, [activeRange.start, activeRange.end]);
    const dateWindow = windowFrom(windowStart, activeRange, NIGHTS);
    return {
        dateWindow,
        label: formatWindowLabel(dateWindow, activeRange),
        rangeNights: rangeNights(activeRange),
        canBack: canPageBack(windowStart, activeRange),
        canForward: canPageForward(windowStart, activeRange, NIGHTS),
        pageBack: () => setWindowStart(pageWindowStart(windowStart, activeRange, NIGHTS, -1)),
        pageForward: () => setWindowStart(pageWindowStart(windowStart, activeRange, NIGHTS, 1)),
        jumpToday: () => setWindowStart(todayWindowStart(DateTime.now().toISODate() ?? activeRange.start, activeRange, NIGHTS))
    };
};
